import { createAsyncTypes } from '../utils'

export const getEnterpriseTypes = createAsyncTypes('GET_ENTERPRISE')
export const getEnterprisePropertiesTypes = createAsyncTypes('GET_ENTERPRISE_PROPERTIES')
